module.exports = __webpack_public_path__ + "media/images/USA-matrimony-banner1-9c2f67bdfc426621b0c0f4a3589fad05.jpg";